import React from "react";
import { Route, Routes } from "react-router-dom";
import PostLoginLayout from "../../partials/Layouts/PostLoginLayout";
import Users from "./Users/Users";
import Profile from "./Profile/Profile";
import ChangePassword from "./Profile/ChangePassword";
import Settings from "./Profile/Settings";
import ProductManagement from "./Profile/ProductManagement";
import Department from "./Profile/Department";
import Role from "./Profile/Role";
import Employee from "./Employees/Employee";
import EmployeeAttendanceReport from "./Reports/EmployeeAttendanceReport";
import MonthlyReport from "./Reports/MonthlyReport";
import RealtimeAttendance from "./Profile/RealtimeAttendance";
import Shifts from "./Profile/Shifts";
import Attendance from "./Reports/Attendance";
import MonthlyReportPayroll from "./Reports/MonthlyReportPayroll";
import Payrolls from "./Profile/Payrolls";
import PayrollView from "./Profile/PayrollView";
import EmployeeMonthlyUpdate from "./Profile/EmployeeMonthlyUpdate";
import Branches from "./Branches/Branches";
import BulkEmployee from "./Employees/BulkEmployee";
import DailyReport from "./Reports/DailyReport";
import WeeklyReport from "./Reports/WeeklyReport";

const Meetings = React.lazy(() => import("./Meetings/Meetings"));

const PrivatePortal = () => {
  return (
    <React.Suspense fallback={<></>}>
      <Routes>
        <Route path="/" element={<PostLoginLayout />}>
          <Route
            path="/change-password"
            element={
              <React.Suspense fallback={<></>}>
                <ChangePassword />
              </React.Suspense>
            }
          />

          <Route
            path="/today-summary"
            element={
              <React.Suspense fallback={<></>}>
                <RealtimeAttendance />
              </React.Suspense>
            }
          />

          <Route
            path="/settings"
            element={
              <React.Suspense fallback={<></>}>
                <Settings />
              </React.Suspense>
            }
          />

          <Route
            path="/shifts"
            element={
              <React.Suspense fallback={<></>}>
                <Shifts />
              </React.Suspense>
            }
          />

          <Route
            path="/departments"
            element={
              <React.Suspense fallback={<></>}>
                <Department />
              </React.Suspense>
            }
          />

          <Route
            path="/branches"
            element={
              <React.Suspense fallback={<></>}>
                <Branches />
              </React.Suspense>
            }
          />

          <Route
            path="/roles"
            element={
              <React.Suspense fallback={<></>}>
                <Role />
              </React.Suspense>
            }
          />

          <Route
            path="/employees"
            element={
              <React.Suspense fallback={<></>}>
                <Employee />
              </React.Suspense>
            }
          />

          <Route
            path="/bulk-employees"
            element={
              <React.Suspense fallback={<></>}>
                <BulkEmployee />
              </React.Suspense>
            }
          />

          <Route
            path="/attendance-logs"
            element={
              <React.Suspense fallback={<></>}>
                <Attendance />
              </React.Suspense>
            }
          />
          <Route
            path="/update-attendance"
            element={
              <React.Suspense fallback={<></>}>
                <EmployeeMonthlyUpdate />
              </React.Suspense>
            }
          />

          <Route
            path="/payrolls"
            element={
              <React.Suspense fallback={<></>}>
                <Payrolls />
              </React.Suspense>
            }
          />

          <Route
            path="/payrolls/:id/details"
            element={
              <React.Suspense fallback={<></>}>
                <PayrollView />
              </React.Suspense>
            }
          />

          <Route
            path="/employee-details"
            element={
              <React.Suspense fallback={<></>}>
                <EmployeeAttendanceReport />
              </React.Suspense>
            }
          />

          <Route
            path="/report/:employeeId"
            element={
              <React.Suspense fallback={<></>}>
                <EmployeeAttendanceReport />
              </React.Suspense>
            }
          />

          <Route
            path="/monthly-summary"
            element={
              <React.Suspense fallback={<></>}>
                <MonthlyReport />
              </React.Suspense>
            }
          />

          <Route
            path="/monthly-summary/make-payroll"
            element={
              <React.Suspense fallback={<></>}>
                <MonthlyReportPayroll />
              </React.Suspense>
            }
          />

          <Route
            path="/daily-report"
            element={
              <React.Suspense fallback={<></>}>
                <DailyReport />
              </React.Suspense>
            }
          />
          <Route
            path="/weekly-report"
            element={
              <React.Suspense fallback={<></>}>
                <WeeklyReport />
              </React.Suspense>
            }
          />
          <Route
            path="/users"
            element={
              <React.Suspense fallback={<></>}>
                <Users />
              </React.Suspense>
            }
          />
          <Route
            path="/profile"
            element={
              <React.Suspense fallback={<></>}>
                <Profile />
              </React.Suspense>
            }
          />
        </Route>
      </Routes>
    </React.Suspense>
  );
};

export default PrivatePortal;
